import React from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { PageCard } from 'components/molecules';
import ContentLoader from 'react-content-loader';

const pageDefault = {
  title: '',
  description: 'Sem páginas recentemente editadas',
  isEditable: false,
}

const PageCardLoader = withTheme(({ theme }) => (
  <LoaderWrapper>
    <ContentLoader
      height={184}
      width={224}
      speed={1}
      primaryColor={theme.colors.bgAnimation}
      secondaryColor={theme.colors.bgLighter}
      title="a carregar páginas editadas recentemente..."
    >
      <rect width="224" height="141" />
      <rect y="153" width="224" height="13" />
      <rect y="172" width="140" height="12" />
    </ContentLoader>
  </LoaderWrapper>
));

const PagesCardList = ({ pages, loading }) => {
  if (loading) {
    return (
      <Wrapper>
        <PageCardLoader />
        <PageCardLoader />
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <PageList>
        {
          (pages && pages.length > 0)
            ? pages.map(page => <PageCard {...page} key={page.key} />)
            : <PageCard {...pageDefault} />
        }
      </PageList>
    </Wrapper>
  );
};

const LoaderWrapper = styled.div`
  width: ${props => props.theme.components.pageCard.width};
  height: ${props => props.theme.components.pageCard.height};
  margin-right: ${props => props.theme.spacing.xs};
  svg {
    width: 100%;
    height: 100%;
  }
`;

const PageList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: ${props => props.theme.spacing.xs};
  & > div {
    margin-right: ${props => props.theme.spacing.xs};
    margin-bottom: ${props => props.theme.spacing.xs};
    &:last-child {
      margin-right: 0;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme.spacing.xl1};
`;

PagesCardList.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      updatedAt: PropTypes.string,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  loading: PropTypes.bool,
};

PagesCardList.defaultProps = {
  pages: [],
  loading: false,
};

export default PagesCardList;
